// client/src/components/RewardDemo.js
// Demo component to test reward popups (remove in production)

import React from 'react';
import { useReward } from '../contexts/RewardContext';
import { HeadlineMedium, LabelMedium } from './Typography';

const RewardDemo = () => {
  const { showLevelComplete, showCourseComplete, showAchievement } = useReward();

  const handleLevelComplete = (levelNumber) => {
    showLevelComplete(levelNumber, {
      customMessage: `Amazing work! You've mastered Level ${levelNumber}.`,
      duration: 10000
    });
  };

  const handleCourseComplete = () => {
    showCourseComplete('Creative Writing Fundamentals', {
      duration: 10000
    });
  };

  const handleAchievement = (achievementName) => {
    showAchievement(achievementName, {
      duration: 10000
    });
  };

  return (
    <div className="max-w-2xl mx-auto p-8 bg-white rounded-lg shadow-lg">
      <HeadlineMedium color="gray-900" className="mb-6 text-center">
        Reward System Demo
      </HeadlineMedium>
      
      <LabelMedium color="gray-600" className="mb-8 text-center">
        Click the buttons below to test different reward popups
      </LabelMedium>

      <div className="space-y-4">
        {/* Level Complete Tests */}
        <div className="space-y-2">
          <LabelMedium color="gray-700">Level Completion Rewards:</LabelMedium>
          <div className="flex flex-wrap gap-2">
            {[1, 2, 3, 5, 10].map(level => (
              <button
                key={level}
                onClick={() => handleLevelComplete(level)}
                className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
              >
                Level {level} Complete
              </button>
            ))}
          </div>
        </div>

        {/* Course Complete Test */}
        <div className="space-y-2">
          <LabelMedium color="gray-700">Course Completion:</LabelMedium>
          <button
            onClick={handleCourseComplete}
            className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors"
          >
            Course Complete
          </button>
        </div>

        {/* Achievement Tests */}
        <div className="space-y-2">
          <LabelMedium color="gray-700">Achievements:</LabelMedium>
          <div className="flex flex-wrap gap-2">
            {[
              'First Lesson',
              'Perfect Score',
              'Speed Reader',
              'Grammar Master',
              'Creative Genius'
            ].map(achievement => (
              <button
                key={achievement}
                onClick={() => handleAchievement(achievement)}
                className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition-colors"
              >
                {achievement}
              </button>
            ))}
          </div>
        </div>
      </div>

      <div className="mt-8 p-4 bg-blue-50 rounded-lg">
        <LabelMedium color="blue-800" className="font-medium mb-2">
          💡 Tips for Asset Creation:
        </LabelMedium>
        <ul className="text-sm text-blue-700 space-y-1">
          <li>• Create 400-600px square videos/GIFs</li>
          <li>• Keep file sizes under 2MB for videos, 1MB for GIFs</li>
          <li>• Use seamless loops (3-5 seconds duration)</li>
          <li>• Place assets in <code>public/images/rewards/</code></li>
          <li>• Follow the naming convention in the README</li>
        </ul>
      </div>
    </div>
  );
};

export default RewardDemo;
